<template>
  <div class="">
    <edit-instance-form
        v-if="showEditForm"
        :instance-id="editingInstance.id"
        :project-id="projectId"
        :organization-id="organizationId"
        :store-name="remoteStoreName ? remoteStoreName : getInstanceType(editingInstance)"
        @abort="showEditForm = false"
    />
    <table-widget
        :id="'datasetsPerSfxdataTable'"
        :can-unlink="true"
        :custom-edit-permission-function="() => { return true; }"
        :data="$store.getters.getInstancesByListName(connectedInstance)"
        :fields="fields"
        :selected-rows="$store.getters.getInstancesByListName(connectedInstance).selected"
        class=""
        @edit="edit"
        @unlink="unlink"
    />
  </div>
</template>

<script>
import TableWidget from "../widgets/TableWidget";
import EditInstanceForm from "@/components/forms/EditInstanceForm.vue";

export default {
  name: "Instances",
  components: {
    EditInstanceForm,
    TableWidget,
  },
  props: {
    projectId: {type: String, required: true,},
    organizationId: {type: String, required: true,},
    connectedInstance: {type: String, default: null},
    remoteStoreName: {type: String, default: null},
  },
  data() {
    return {
      showEditForm: false,
      editingInstance: null,
      previewPath: null,
      fields: [
        {
          name: 'Name',
          id: 'name',
          type: 'string',
        },
        {
          name: 'Type',
          id: 'type',
          type: 'string',
        },
        {
          name: 'Edit',
          id: 'edit',
          type: 'editPopup',
        },

      ],
    };
  },
  watch: {
    id: function () {
      this.loadInstances();
    },
    connectedInstance: function () {
      this.loadInstances();
    },
  },
  beforeMount() {
    this.loadInstances();
  },
  methods: {
    getInstanceType(item) {
      if(!item || !item.type) {
        return null;
      }
      const {type} = item;
      return type.charAt(0).toUpperCase() + type.slice(1);
    },
    edit(id, item) {
      this.showEditForm = true;
      this.editingInstance = item;
    },
    unlink(item) {
      this.$store.dispatch('removeInstance', {
        id: item.id,
        listName: this.connectedInstance
      });
      this.$emit('clickAsset', item.assetId, 'remove');
    },
    loadInstances() {
      let args = {
        id: this.projectId,
        listName: this.connectedInstance,
        cid: this.connectedInstance,
        include: ['instanceAndAsset'],
      };
      this.$store.dispatch('loadConnectionsWithInstances', args);
    },
  },
}
</script>
